import { EventHeader } from 'ai-constants'
import createFetchClient, { Middleware } from 'openapi-fetch'
import createClient from 'openapi-react-query'
import { stringify } from 'qs'
import * as accountService from './account-service/sdk'
import * as authzService from './authz-service/sdk'
import * as billingService from './billing-service/sdk'
import * as inspectionService from './inspection-service/sdk'
import * as notificationService from './notification-service/sdk'
import * as trackingService from './tracking-service/sdk'

export const autoinspectorApi = createFetchClient<
  accountService.paths &
    authzService.paths &
    inspectionService.paths &
    billingService.paths &
    notificationService.paths &
    trackingService.paths
>({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  credentials: 'include',
  querySerializer(queryParams) {
    return stringify(queryParams)
  },
})

export const hydrateRequestHeaders = (request: {
  headers: {
    set: (key: string, value: string) => void
  }
}) => {
  if (typeof window !== 'undefined') {
    if (typeof window.location?.href === 'string') {
      request.headers.set(
        'x-current-url' satisfies EventHeader,
        window.location.href,
      )
    }

    if (typeof window.screen !== 'undefined') {
      const { height, width } = window.screen
      if (typeof width === 'number') {
        request.headers.set(
          'x-screen-width' satisfies EventHeader,
          String(width),
        )
      }
      if (typeof height === 'number') {
        request.headers.set(
          'x-screen-height' satisfies EventHeader,
          String(height),
        )
      }
    }
  }
}

const clientCredentials: Middleware = {
  async onRequest({ request }) {
    hydrateRequestHeaders(request)

    return request
  },
}

autoinspectorApi.use(clientCredentials)

export const $autoinspectorApi = createClient(autoinspectorApi)

export type AutoinspectorApi = {
  accountService: accountService.components
  authzService: authzService.components
  inspectionService: inspectionService.components
  billingService: billingService.components
  notificationService: notificationService.components
  trackingService: trackingService.components
}

export type AutoinspectorApiPaths = {
  accountService: accountService.paths
  trackingService: trackingService.paths
}

export const autoinspectorApiEnums = {
  billingService,
  authzService,
}
